import { render, staticRenderFns } from "./OutputActionsMenu.vue?vue&type=template&id=48d65931&scoped=true"
import script from "./OutputActionsMenu.vue?vue&type=script&lang=js"
export * from "./OutputActionsMenu.vue?vue&type=script&lang=js"
import style0 from "./OutputActionsMenu.vue?vue&type=style&index=0&id=48d65931&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d65931",
  null
  
)

export default component.exports